import React from "react"

const Footer = () => {
  return (
    <>
      <footer>
        <div className='conatiner footer text-center top'>
          <div className='img'>
          </div>
          <p>© 2022. All rights reserved by Gaurav Jangam.</p>
        </div>
      </footer>
    </>
  )
}

export default Footer
